export const enum ItemDisplayMode {
    Output = 'output',
    Original = 'original',
    Compare = 'compare',
}

export const MAX_AI_TRY_TIME = 4